import { useAuth } from "../context/AuthContext";

export function useTier() {
  const { user, loading } = useAuth();
  const storedTier = user?.subscription_tier || "free";
  const tier = storedTier === "plus" ? "premium" : "free";

  return {
    tier,
    storedTier,
    isPremium: tier === "premium",
    isLoading: loading,
    currentPeriodEnd: user?.current_period_end || null,
  };
}
